import React from 'react';

const StudioKohlerLargeLogo = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "173", height: "22", viewBox: "0 0 173 22", fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.635 0.35C95.1038 0.35 90.6338 4.9736 90.6338 10.6586C90.6338 16.3557 95.1158 20.9671 100.642 20.9671C106.169 20.9671 110.643 16.3394 110.643 10.6504C110.639 4.95734 106.157 0.35 100.635 0.35ZM105.14 10.6463C105.14 13.4522 103.122 15.7254 100.638 15.7254C98.158 15.7294 96.1363 13.4603 96.1363 10.6504C96.1323 7.85264 98.154 5.57947 100.634 5.57947C103.126 5.5754 105.14 7.84857 105.14 10.6463Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M1.85996 14.2167C1.77623 18.2913 4.63528 19.5397 8.19613 19.5397C10.2338 19.5397 13.336 18.4011 13.336 15.518C13.336 13.2733 11.1589 12.3827 9.34055 11.9395L5.01808 10.8578C2.73323 10.2763 0.639782 9.19458 0.639782 6.08778C0.639782 4.14806 1.86395 0.512618 7.33084 0.512618C11.1908 0.512618 14.5084 2.59059 14.5084 6.66929H12.6582C12.5226 3.67228 10.1301 2.12295 7.35476 2.12295C4.82668 2.12295 2.486 3.12331 2.486 6.05931C2.486 7.9177 3.81783 8.72286 5.42082 9.08072L10.154 10.2722C12.9014 11.0204 15.1862 12.2688 15.1862 15.4854C15.1862 16.8436 14.6439 21.1419 7.76149 21.1419C3.16787 21.1419 -0.205571 19.0355 0.00975459 14.2086H1.85996V14.2167Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M20.4615 6.42532H23.3166V7.89332H20.4615V17.5431C20.4615 18.6817 20.625 19.3446 21.8492 19.43C22.3396 19.43 22.8301 19.4015 23.3166 19.3446V20.841C23.0574 20.841 22.8062 20.8553 22.555 20.8695C22.3038 20.8837 22.0525 20.898 21.7933 20.898C19.5085 20.898 18.719 20.1213 18.7469 17.6814V7.89332H16.2985V6.42532H18.7469V2.12703H20.4615V6.42532Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M34.9763 20.7353H36.5554V6.4253H34.8407V13.9361C34.8407 16.8477 33.5647 19.678 30.6259 19.678C27.9064 19.678 26.9534 18.3198 26.8737 15.7416V6.4253H25.159V15.7172C25.159 19.0762 26.5188 21.1541 30.0796 21.1541C32.1731 21.1541 34.0233 20.0724 34.9205 18.1571H34.9763V20.7353Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4147 20.7353H50.9938V0.935533H49.2791V9.14578H49.2233C48.5135 7.0922 46.4201 6.01051 44.3545 6.01051C40.0839 6.01051 38.0463 9.50363 38.0463 13.5823C38.0463 17.661 40.0839 21.1541 44.3545 21.1541C46.3962 21.1541 48.6252 19.9057 49.3589 18.0189H49.4147V20.7353ZM49.2788 13.5783C49.2788 16.5428 47.9749 19.678 44.3582 19.678C41.0964 19.678 39.7646 16.5428 39.7646 13.5783C39.7646 10.6138 41.0964 7.47857 44.3582 7.47857C47.9749 7.47857 49.2788 10.6138 49.2788 13.5783Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M53.6861 0.935533H55.4007V3.73735H53.6861V0.935533Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M53.6861 6.4253H55.4007V20.7353H53.6861V6.4253Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0174 21.1501C68.288 21.1501 70.6526 17.6813 70.6526 13.5783C70.6526 9.47517 68.288 6.00645 64.0174 6.00645C59.7468 6.00645 57.3822 9.4711 57.3822 13.5783C57.3822 17.6854 59.7468 21.1501 64.0174 21.1501ZM64.0177 19.6779C60.7559 19.6779 59.0971 16.5996 59.0971 13.5782C59.0971 10.5568 60.7559 7.47846 64.0177 7.47846C67.2795 7.47846 68.9383 10.5568 68.9383 13.5782C68.9383 16.5996 67.2795 19.6779 64.0177 19.6779Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M128.787 0.919272L128.795 20.6987L140.048 20.6946V15.6359H134.102L134.094 0.915205L128.787 0.919272Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M111.528 20.7069L111.512 0.927442L116.816 0.923376L116.82 7.86488L122.163 7.85674L122.159 0.923376L127.463 0.919309L127.471 20.6987H122.171V13.3424L116.82 13.3506L116.828 20.7028L111.528 20.7069Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M85.8488 10.3658L93.5008 0.939642H86.6303L81.622 6.82175V0.939642L76.3226 0.943708L76.3306 20.7231H81.626L81.622 13.6718H81.634L87.5873 20.7231H94.6054L85.8488 10.3658Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M151.89 0.903043L146.443 0.915243H141.128L141.14 20.6947L151.95 20.6865L151.942 16.0426L146.567 16.0467V13.0334L151.475 13.0212L151.471 8.60091H146.551L146.575 5.47785L151.89 5.46158V0.903043Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.442 20.6865L162.92 12.7731C169.331 8.36505 165.619 0.886771 159.769 0.894904L153.126 0.89897L153.138 20.6743L158.326 20.6703V14.6112L162.644 20.6865H168.442ZM161.676 7.38502C161.676 8.43825 160.834 9.29221 159.806 9.29221L158.302 9.28814V5.48597L159.798 5.48191C160.834 5.48191 161.676 6.3318 161.676 7.38502Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.621 20.7475H171.979L171.337 19.7512C171.712 19.739 172.011 19.5845 172.011 19.1534C172.011 18.6858 171.637 18.5801 171.258 18.5801H170.325L170.329 20.7475H170.624V19.7472H170.983L171.621 20.7475ZM171.078 19.4476C171.349 19.453 171.712 19.4603 171.712 19.1494C171.708 18.9258 171.421 18.8892 171.189 18.8892H170.623V19.4422C170.623 19.4463 170.982 19.4463 170.982 19.4463C171.012 19.4463 171.045 19.4469 171.078 19.4476Z",
    fill: "currentColor"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.1 19.678C169.1 18.5719 169.962 17.6977 171.05 17.6977C172.139 17.6977 173 18.5719 173 19.674C173.004 20.776 172.143 21.6543 171.054 21.6543C169.962 21.6543 169.1 20.7841 169.1 19.678ZM172.701 19.674C172.701 18.7468 171.935 18.0026 171.054 18.0026C170.165 18.0026 169.407 18.7468 169.407 19.678C169.407 20.6093 170.165 21.3494 171.062 21.3494C171.943 21.3453 172.701 20.6052 172.701 19.674Z",
    fill: "currentColor"
  }
));

export { StudioKohlerLargeLogo };
